module.exports = __webpack_public_path__ + "img/phone_ocho.49cf5781.png";